import { render, staticRenderFns } from "./AchFieldsForm.vue?vue&type=template&id=0cb63886&scoped=true"
import script from "./AchFieldsForm.vue?vue&type=script&lang=js"
export * from "./AchFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./AchFieldsForm.vue?vue&type=style&index=0&id=0cb63886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb63886",
  null
  
)

export default component.exports